import ReportResource from "./report.resource";

const reportModule = angular
  .module("app.resources.report", [])
  .service("Report", ReportResource);

export default reportModule;



// WEBPACK FOOTER //
// ./src/resources/report/report.module.js